import { isWeb } from '@helpers';

export const timelineAvailable = isWeb;
export const machineEventsMainMenuAvailable = false;

export const SCREEN_FEATURE_FLAGS: Record<string, string> = {
  Dashboard: 'dashboard-show-dashboard',
  Planboard: 'machine-planboard',
};
